import { DownloadableItem, CreatorDownloadableItem } from 'types';
export const getDownloadableItemIds = (item: DownloadableItem): string[] =>
    (item as CreatorDownloadableItem).samples
        ? (item as CreatorDownloadableItem).samples.map((i) => i.id)
        : [item.id];
